<div class="delivery-modal">
  <h2 class="label-title">{{this.modalTitle}}</h2>
  <h5 class="label-text">{{this.modalText}}</h5>

  <ion-button expand="block"
    *ngIf="modalOkButton"
    (click)="onOkButtonClick()"
    class="button apply">
    {{this.modalOkButton}}
  </ion-button>

  <ion-button expand="block"
              (click)="onCancelButtonClick()"
              class="button cancel">
    Cancel
  </ion-button>
</div>
